import CustomerDetail from './Detail';
export default CustomerDetail;